import 'css-chunksrc/client/scenes/project/descriptionForm/styles.scss';export default {
  "descriptionForm": "_descriptionForm_1y1zc_1",
  "title": "_title_1y1zc_8",
  "input": "_input_1y1zc_14"
};